import {Injectable} from '@angular/core';

@Injectable()
export class IFrameRoutingService {
  constructor() {
    // console.log('IFrameRoutingService');
  }
}
